import { Row } from 'antd'
import QuoteFeedbackError from 'app/components/Core/QuoteFeedback/Error'
import Form from 'app/components/Core/QuoteFeedback/Form'
import Container from 'app/components/UI-Elements/Layout/Container'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { TransactionalSuccessType } from 'app/constants/Enums'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useShow } from 'app/lib/hooks/useApi'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useParams } from 'react-router-dom'

const QuoteFeedback: React.FC<PageProps> = (props) => {
  const { title } = useTitle(props)
  const navigate = useNavigate()
  const { parameterize } = ToolBox
  const { formatMessage } = useIntl()
  const { transactional_id } = useParams<{ transactional_id: string }>()
  const { response: rental, loading, execute } = useShow<IRental>(RecordType.rental)
  const [subtitle, setSubtitle] = useState<string>(null)
  const onSuccess = () =>
    navigate({
      pathname: Routes.Transactional.member(transactional_id).confirmation,
      search: parameterize({ type: TransactionalSuccessType.quote_feedback })
    })

  useEffect(() => {
    execute({ id: Number(transactional_id) })
  }, [transactional_id])

  useEffect(() => {
    if (rental?.project_name) {
      const subtitle = formatMessage(
        { id: 'component.feedback.drawer.subtitle.review.update' },
        { project_name: rental?.project_name, rental_code: rental?.rental_code }
      )
      setSubtitle(subtitle)
    }
  }, [rental])

  return (
    <Container card={false}>
      <Row justify="center">
        <KCol xs={24} md={16} lg={12} card title={title} subtitle={subtitle} loading={loading}>
          <QuoteFeedbackError quote={rental?.quote}>
            <Form props={{ onSuccess: onSuccess }} member={{ quote_id: rental?.quote?.id }} />
          </QuoteFeedbackError>
        </KCol>
      </Row>
    </Container>
  )
}

export default QuoteFeedback
